document.addEventListener('DOMContentLoaded', e => {
    const autoSendForms = document.querySelectorAll('.auto-send-form');

    autoSendForms.forEach(form => {
        // Используем делегирование событий для эффективности
        form.addEventListener('change', (event) => {
            if (event.target.classList.contains('on-change')) {
                form.submit();
            }
        });
    });


    const filterBars = document.querySelectorAll('.dashboard-page__filter-bar');

    filterBars.forEach(bar => {
        const showButton = bar.querySelector('.dashboard-page__filter-bar__show-button');
        if (showButton) {
            const updateCount = () => {
                const hiddenElements = bar.querySelectorAll('.dashboard-page__filter-bar__el--hide-mobile');
                showButton.dataset.count = Array.from(hiddenElements).filter(el =>
                    !el.classList.contains('dashboard-page__filter-bar__el--show')
                ).length;
            };

            updateCount();

            showButton.addEventListener('click', (e) => {
                e.preventDefault();
                const hiddenElements = bar.querySelectorAll('.dashboard-page__filter-bar__el--hide-mobile');
                hiddenElements.forEach(el => {
                    el.classList.toggle('dashboard-page__filter-bar__el--show')
                });
                updateCount();
            });
        }
    });
});
